<template>
  <div class="container">
    <div class="login-box">
      <div class="login-title">最慧学·登录</div>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="账号">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleLogin" size="small">登 录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {login} from '../apis/zhxApi'
import {setToken} from '../utils/auth'
import {Message} from 'element-ui'

export default {
  name: 'Login',
  data () {
    return {
      form: {
        username: undefined,
        password: undefined
      },
      rules: {
        username: [
          { required: true, message: '请输入最慧学账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入最慧学密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleLogin () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loginZhx()
        } else {

        }
      })
    },
    loginZhx: function () {
      login(this.form.username, this.form.password).then(res => {
        console.log(res)
        if (res.code !== 200) {
          Message({
            message: '请求错误: ' + res.msg,
            type: 'error'
          })
          return
        }
        setToken(res.data.accessToken)
        window.location.href = '/PaperList#/'
      })
    }
  }
}
</script>

<style scoped>
.container {
  padding: 16px;
  text-align: center;
}

.login-title {
  width: 468px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  padding: 24px 0;
}

.login-box {
  width: 360px;
  display: inline-block;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue